import type { FundingStatus, Stage } from '../api/types'
import { FUNDING_LABELS, formatCrore, plural } from '../lib/format'

/** Small coloured pills used on cards, tables and headers. Colours live in index.css. */

export function StageBadge({ stage }: { stage: Stage }) {
  return <span className={`badge stage-${stage.toLowerCase()}`}>{stage}</span>
}

export function FundingBadge({ status }: { status: FundingStatus }) {
  return <span className={`badge funding-${status.toLowerCase()}`}>{FUNDING_LABELS[status]}</span>
}

export function ValueBadge({ rupees }: { rupees: number }) {
  return <span className="badge value">{formatCrore(rupees)}</span>
}

export function OverdueBadge({ days }: { days: number }) {
  return <span className="badge overdue">{plural(days, 'day')} overdue</span>
}

export function ArchivedBadge() {
  return <span className="badge archived">Archived</span>
}
